import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import Text from 'components/_core/Text';
import TreezorUpload, {
  FILE_SIZE,
  FILE_TYPE,
} from 'features/Onboarding/legacy/components/TreezorUpload';
import { uploadKyc } from 'features/Storage/upload';

import Clipboard from '../assets/Clipboard@2x.png';
import locales from './locales';
import * as S from './styles';
import { ComponentProps } from './types';

const VerificationDocumentUpload: FC<ComponentProps> = ({
  onSuccessfulUpload,
}) => (
  <TreezorUpload
    errorMessage={locales.uploadFailureMessage}
    fileTypes={FILE_TYPE.ALLOWED_DOCUMENTS}
    maxByteSizeParam={FILE_SIZE.SUPPORTING_DOCUMENTS}
    onSuccessfulUpload={onSuccessfulUpload}
    uploadFile={uploadKyc}
  >
    <S.UploadMessageWrapper>
      <Image boxSize="120px" src={Clipboard} />

      <Text
        fontWeight="weight-500"
        marginBottom="space-8"
        size="lg"
        variant="primary"
      >
        {locales.uploadTitle}
      </Text>

      <Text variant="light">{locales.uploadBrowseMessage}</Text>
    </S.UploadMessageWrapper>
  </TreezorUpload>
);

export default VerificationDocumentUpload;
